var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90909 3.63636V12C6.90909 13.6073 5.60727 14.9091 4 14.9091C2.39273 14.9091 1.09091 13.6073 1.09091 12V2.90909C1.09091 1.90545 1.90545 1.09091 2.90909 1.09091C3.91273 1.09091 4.72727 1.90545 4.72727 2.90909V10.5455C4.72727 10.9455 4.4 11.2727 4 11.2727C3.6 11.2727 3.27273 10.9455 3.27273 10.5455V3.63636H2.18182V10.5455C2.18182 11.5491 2.99636 12.3636 4 12.3636C5.00364 12.3636 5.81818 11.5491 5.81818 10.5455V2.90909C5.81818 1.30182 4.51636 0 2.90909 0C1.30182 0 0 1.30182 0 2.90909V12C0 14.2109 1.78909 16 4 16C6.21091 16 8 14.2109 8 12V3.63636H6.90909Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.c27d9072.svg";
export { ForwardRef as ReactComponent };